// Login page: doors animation and form handlers

export function initLoginPage(): void {
    const doc = $('html').addClass('js-login');
    const container = $('#container');
    const formWrapper = $('#form-wrapper');
    const formBlock = $('#form-block');
    const formViewport = $('#form-viewport');
    const forms = formViewport.children('form');

    const topDoor = $('<div id="top-door" class="form-door"><div></div></div>').appendTo(formViewport);
    const botDoor = $('<div id="bot-door" class="form-door"><div></div></div>').appendTo(formViewport);
    const doors = topDoor.add(botDoor);

    const formSwitch = $('<div id="form-switch"><span class="button-group"></span></div>').appendTo(formBlock).children();

    const hash = (document.location.hash.length > 1) ? document.location.hash.substring(1) : false;

    let centered: boolean;
    let currentForm: JQuery<any>;
    let animInt: number;
    let maxHeight: number = 0;
    let blocHeight: number;

    // ---- Form switch behavior ----

    forms.each(function (i) {
        const form = $(this);
        const height = form.outerHeight()!;
        const active = (hash === false && i === 0) || (hash === this.id);
        const color = this.className.match(/[a-z]+-gradient/)
            ? ' ' + (/([a-z]+)-gradient/.exec(this.className)![1]) + '-active'
            : '';

        form.data('height', height);
        if (maxHeight === 0 || height > maxHeight) maxHeight = height;

        form.data('button', $('<a href="#' + this.id + '" class="button anthracite-gradient' + color + (active ? ' active' : '') + '">' + this.title + '</a>')
            .data('form', form)
            .appendTo(formSwitch)
        );
        if (form.attr('id') == 'form-register2' || form.attr('id') == 'form-register')
            $(form.data('button')).css('display', 'none');

        if (active) {
            currentForm = form;
            formViewport.height(height);
        } else {
            form.hide();
        }
    });

    blocHeight = formBlock.height()! - currentForm.data('height');

    function handleLoginResize(): void {
        centered = (container.css('position') === 'absolute');
        if (!centered) {
            formWrapper.css('min-height', (blocHeight + maxHeight + 20) + 'px');
            container.css('margin-top', '');
        } else {
            formWrapper.css('min-height', '');
            if (parseInt(container.css('margin-top'), 10) === 0) {
                centerForm(currentForm, false);
            }
        }
    }

    $(window).bind('normalized-resize', handleLoginResize);
    handleLoginResize();

    (formSwitch as any).switchForm = function (event: Event, x: JQuery): void {
        const link = x;
        const form = link.data('form');
        const previousForm = currentForm;

        if (event.preventDefault != null) event.preventDefault();
        if (link.hasClass('active')) return;

        forms.each(function () {
            const f = $(this);
            const hidden = f.is(':hidden');
            const h = f.show().outerHeight()!;
            f.data('height', h);
            if (hidden) f.hide();
        });

        formWrapper.clearMessages();
        if (animInt) clearTimeout(animInt);
        formViewport.stop(true);
        currentForm.data('button').removeClass('active');
        link.addClass('active');
        currentForm = form;

        if (doc.hasClass('csstransitions')) {
            doors.removeClass('door-closed').addClass('door-down');
            animInt = window.setTimeout(function () {
                doors.addClass('door-closed');
                animInt = window.setTimeout(function () {
                    previousForm.hide();
                    form.show();
                    centerForm(form, true);
                    formViewport.animate({ height: form.data('height') + 'px' }, function () {
                        doors.removeClass('door-closed');
                        animInt = window.setTimeout(function () {
                            doors.removeClass('door-down');
                        }, 300);
                    });
                }, 300);
            }, 300);
        } else {
            topDoor.animate({ top: '0%' }, 300);
            botDoor.animate({ top: '50%' }, 300, function () {
                previousForm.hide();
                form.show();
                centerForm(form, true);
                formViewport.animate({ height: form.data('height') + 'px' }, {
                    step: function () {
                        topDoor.hide().show();
                        botDoor.hide().show();
                        formSwitch.hide().show();
                    },
                    complete: function () {
                        topDoor.animate({ top: '-50%' }, 300);
                        botDoor.animate({ top: '105%' }, 300);
                        formSwitch.hide().show();
                    }
                });
            });
        }
    };

    formSwitch.on('click', 'a', function (event) {
        (formSwitch as any).switchForm(event, $(this));
    });

    centerForm(currentForm, false);

    function centerForm(form: JQuery, animate: boolean, ignore?: any): void {
        if (centered) {
            let siblings = formWrapper.siblings().not('.closing');
            let finalSize = blocHeight + form.data('height');
            if (ignore) siblings = siblings.not(ignore);
            siblings.each(function () {
                finalSize += $(this).outerHeight(true)!;
            });
            container[animate ? 'animate' : 'css']({ marginTop: -Math.round(finalSize / 2) + 'px' });
        }
    }

    function displayError(message: string): void {
        const msg = formWrapper.message(message, {
            append: false,
            arrow: 'bottom',
            classes: ['red-gradient'],
            animate: false
        });
        centerForm(currentForm, true, 'fast');
        msg.bind('endfade', function () {
            centerForm(currentForm, true, msg.get(0));
        }).hide().slideDown('fast');
    }

    function displayLoading(message: string): void {
        const msg = formWrapper.message('<strong>' + message + '</strong>', {
            append: false,
            arrow: 'bottom',
            classes: ['blue-gradient', 'align-center'],
            stripes: true,
            darkStripes: false,
            closable: false,
            animate: false
        });
        centerForm(currentForm, true, 'fast');
        msg.bind('endfade', function () {
            centerForm(currentForm, true, msg.get(0));
        }).hide().slideDown('fast');
    }

    // ---- Login form AJAX ----

    $('#form-login').submit(function (event) {
        if (event.preventDefault != null) event.preventDefault();

        $.ajax('/login?login=1', {
            type: 'POST',
            data: {
                login: $('#login').val(),
                pass: $('#pass').val(),
            },
            success: function (data) {
                if (data == 'OK') {
                    document.location.href = '/dashboard';
                } else {
                    formWrapper.clearMessages();
                    displayError(data);
                }
            },
            error: function () {
                formWrapper.clearMessages();
                displayError('Error while contacting server, please try again');
            },
        });
    });

    // ---- Password recovery ----

    $('#form-password').submit(function (event) {
        if (event.preventDefault != null) event.preventDefault();

        const mail = $.trim($('#mail').val() as string);

        if (mail.length === 0) {
            displayError('Please fill in your email');
            return false;
        }

        const emailRe = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
        if (!emailRe.test(mail)) {
            formWrapper.clearMessages('Please fill in your email');
            displayError('Email is not valid');
            return false;
        }

        formWrapper.clearMessages();
        displayLoading('Sending credentials...');

        if (event.preventDefault != null) event.preventDefault();

        $.ajax('/newpassword', {
            type: 'POST',
            data: { mail: mail },
            success: function (data) {
                if (data == '') {
                    document.location.href = '/dashboard';
                } else {
                    formWrapper.clearMessages();
                    displayError(data);
                }
            },
            error: function () {
                formWrapper.clearMessages();
                displayError('Error while contacting server, please try again');
            },
        });
    });
}

declare function deleteCookie(name: string, path: string, domain: string): void;
